export default "__VITE_ASSET__b9629ff0__"